module.exports = __webpack_public_path__ + "img/offers.by.pair.e6a9fcb8.png";